import React from 'react';

// ─────────────────────────────────────────────
// Section wrapper (시안 .section)
// ─────────────────────────────────────────────
export const Section: React.FC<{
  id?: string;
  refCb?: (el: HTMLElement | null) => void;
  eyebrow?: string;
  title?: string;
  children: React.ReactNode;
  surface?: boolean;
}> = ({ id, refCb, eyebrow, title, children, surface }) => (
  <section
    id={id}
    ref={refCb as any}
    className={`scroll-mt-[100px] border-b border-ca-line-soft px-4 py-5 ${surface ? 'bg-ca-surface' : 'bg-frame'}`}
  >
    {eyebrow && (
      // 운영 페이지 heading 구조 동등 — 각 섹션 헤더는 h2 (h1 은 Hero 의 단지명 단일).
      <h2 className="mb-2 flex items-center gap-2 text-[15.75px] font-extrabold uppercase text-accent-dark">
        <span className="inline-block h-px w-3.5 bg-accent" />
        {eyebrow}
      </h2>
    )}
    {title && (
      <h3 className="mb-3 text-[17px] font-extrabold leading-snug tracking-tight text-ink">
        {title}
      </h3>
    )}
    {children}
  </section>
);
